/* eslint-disable import/prefer-default-export */
import { BatchModeEnums } from '@/components/CourseAccessRevoke/utils/utils';
import {
  ICourseDescription,
  ICoursePlanFeatures,
  ICoursePlans,
} from '@/interfaces/courseDescription';

export const handleCourseExpiryLogic = (courseDetails: ICourseDescription) => {
  if (
    [BatchModeEnums.LIVE, BatchModeEnums.HYBRID, BatchModeEnums.OFFLINE].includes(
      courseDetails?.mode as BatchModeEnums
    )
  ) {
    const start = new Date();
    const end = new Date(courseDetails?.config?.classEndDate ?? '');

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return courseDetails?.classTimings?.courseValidity || 0;
    }

    const yearDiff = end.getUTCFullYear() - start.getUTCFullYear();
    const monthDiff = end.getUTCMonth() - start.getUTCMonth();
    const dayDiff = end.getUTCDate() - start.getUTCDate();

    let totalMonths = yearDiff * 12 + monthDiff;

    // Round up if days >= 15
    if (dayDiff >= 15) {
      totalMonths += 1;
    }
    return totalMonths + (courseDetails?.classTimings?.courseValidity ?? 0);
  }

  return courseDetails?.config?.courseValidity || 0;
};

export const formatPlanFeaturesArray = (plan: ICoursePlans) => {
  const tempPlanArray: ICoursePlanFeatures[] = plan.features || [];
  if (plan.isCourseExpiryEnabled) {
    tempPlanArray.unshift({
      _id: '1',
      text: 'Extended Access',
      subText: `Access to recorded content for ${handleCourseExpiryLogic({
        batchMode: '',
        classTimings: {
          endDate: '',
          startDate: '',
          courseValidity: 1,
        },
      } as ICourseDescription)} months`,
      isAvailable: false,
    });
  }
  return tempPlanArray;
};
